/** @jsx jsx */
// @ts-check

export { default } from './ProductFiltersBase';
